import BoxMobileComponent from 'components/box-mobile'
import { ArrivalCarpoolIcon } from 'components/icons/ArrivalCarpoolIcon'
import { DismissalCarpoolIcon } from 'components/icons/DismissalCarpoolIcon'
import React from 'react'
import { Link } from 'react-router-dom'
import { SchoolStatProps } from 'types/SchoolTypes'
import { isWeb } from 'utils/constants'
import './index.css'

const AddressAddComponent: React.FC<{
  id: string
  schoolStats?: SchoolStatProps
  showAM?: boolean
  showPM?: boolean
}> = ({ id, schoolStats, showAM, showPM }) => {
  if (!showAM && !showPM) return null
  const { registeredUsers, pickupUsers, dropoffUsers } = schoolStats ?? {
    registeredUsers: 0,
    pickupUsers: 0,
    dropoffUsers: 0,
  }

  // Determine the primary action based on whether we're showing Morning or Afternoon
  return (
    <div {...(isWeb ? { className: 'mt-2' } : { className: 'max-w-[768px] mx-auto' })}>
      <div className='flex flex-col p-2 gap-2 md:flex-row md:items-center md:justify-between mb-2'>
        {/* Registered Users */}
        <div className='flex gap-2 items-center'>
          <p className='text-yellow-bold text-4xl font-bold'>{registeredUsers}</p>
          <div>
            <p className='text-[#666666] font-normal'>Parents are part of your community</p>
            <p className='text-[#474747] font-semibold'>
              {showAM ? pickupUsers : dropoffUsers} looking for {showAM ? 'morning' : 'afternoon'} carpool
            </p>
          </div>
        </div>
      </div>

      {/* Carpool configuration */}
      <div className='p-2'>
        {/* <div className={`flex gap-2 pb-3 ${isWeb ? 'w-full' : ''} items-stretch`}> */}
        {/* Morning Carpool Configuration */}
        {showAM ? (
          <BoxMobileComponent
            name='Morning Carpool'
            tagline={'Needs pick up location'}
            bgColor={'#FEFCE8'}
            icon={<ArrivalCarpoolIcon size={32} />}
            iconColor={'#F59E42'}
            className='w-full h-full'
            data_testid='arrival-carpool-box-testid'
            to={`/carpool/request/arrival?id=${id}`}
          />
        ) : (
          <BoxMobileComponent
            name='Afternoon Carpool'
            tagline={'Needs drop off location'}
            bgColor={'#FEFCE8'}
            icon={<DismissalCarpoolIcon size={32} />}
            iconColor={'#F59E42'}
            className='w-full h-full'
            data_testid='dismissal-carpool-box-testid'
            to={`/carpool/request/dismissal?id=${id}`}
          />
        )}
        <Link
          to={`/hub?id=${id}`}
          className='block text-center mt-4 text-sm font-semibold text-gray-600 hover:underline'
        >
          Go back to your school hub
        </Link>
      </div>
    </div>
  )
}

export default AddressAddComponent
